import { XMarkIcon } from '@heroicons/react/24/outline';
import { format } from 'date-fns';

const POItemDetailModal = ({ item, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      return format(new Date(dateString), 'MMM dd, yyyy HH:mm');
    } catch {
      return dateString;
    }
  };

  const detailFields = [
    { label: 'PO Number', value: item['PO Number'] },
    { label: 'Item Code', value: item['Item Code'] },
    { label: 'SKU', value: item.SKU },
    { label: 'Drop', value: item.Drop },
    { label: 'Item Quantity', value: item['Item Quantity'] },
    { label: 'Pack Type', value: item['Pack Type'] },
    { label: 'Item CBM', value: item['Item CBM'] },
    { label: 'Item Weight', value: item['Item Weight'] },
    { label: 'IncoTerm', value: item.IncoTerm },
    { label: 'Item Unit Price', value: item['Item Unit Price'] ? `$${item['Item Unit Price'].toLocaleString()}` : '-' },
    { label: 'Height (cm)', value: item['Height (cm)'] },
    { label: 'Length (cm)', value: item['Length (cm)'] },
    { label: 'Width (cm)', value: item['Width (cm)'] },
    { label: 'Item Description', value: item['Item Description'] },
    { label: 'Vendor', value: item.Vendor },
    { label: 'Filename', value: item.filename },
    { label: 'Source File', value: item.source_file },
    { label: 'Processed At', value: formatDate(item.processed_at) },
    { label: 'Last Updated', value: formatDate(item.last_updated) },
  ];

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={onClose} />

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="flex items-start justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                PO Item Details
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {detailFields.map((field, index) => (
                <div key={index} className="border-b border-gray-200 pb-2">
                  <dt className="text-sm font-medium text-gray-500">{field.label}</dt>
                  <dd className="mt-1 text-sm text-gray-900 break-words">
                    {field.value || '-'}
                  </dd>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              onClick={onClose}
              className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default POItemDetailModal;
